/* global google */

import React, { useCallback, useState } from 'react'
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api'
import { Marker, InfoWindow } from '@react-google-maps/api'

import { Loader } from '@elements'

export function LocationMap(props) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyDaGB7tA0uYRP-Q7XiX5L-KrJ-G8cqrOLM',
    // ...otherOptions
  })

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>
  }

  return isLoaded ? (
    <Map {...props} google={google} />
  ) : (
    <div className="relative py-20 xl:py-40 pr-20">
      <Loader />
    </div>
  )
}

export default LocationMap

function Map({
  google,
  onSelectedChange,
  locations = [],
  selected = { address: { locationName: '' } },
}) {
  const [map, setMap] = useState()
  const [googleMarkers, setGoogleMarkers] = useState([])

  const onLoadMap = useCallback(
    function onLoad(map) {
      setMap(map)
    },
    [setMap]
  )

  const onLoad = marker => {
    const markerCopy = googleMarkers.slice()
    markerCopy.push(marker)
    setGoogleMarkers(markerCopy)
  }

  const bounds = new google.maps.LatLngBounds()

  const markers = locations.map((location, idx) => {
    bounds.extend(new google.maps.LatLng(location.latitude, location.longitude))

    return (
      <Marker
        key={location.address.locationName}
        onLoad={onLoad}
        clickable={true}
        onClick={() => {
          onSelectedChange(location)
        }}
        position={{
          lat: location.latitude,
          lng: location.longitude,
        }}
      >
        {location.address.locationName === selected.address.locationName && (
          <InfoWindow>
            <div className="p-2">
              <h2 className="mb-2">
                <b>{location.address.locationName}</b>
              </h2>
              <div className="mb-2">
                {location.address.line1} <br />
                {location.address.city}, {location.address.state}{' '}
                {location.address.zip}
              </div>
              <div>
                <b>Dates and Times:</b>
                {location.pollingHours.split(/\r?\n/).map(line => {
                  return <p key={line}>{line}</p>
                })}
              </div>
            </div>
          </InfoWindow>
        )}
      </Marker>
    )
  })

  if (map) {
    map.fitBounds(bounds)
  }

  const center = bounds.getCenter()

  return (
    <GoogleMap
      onLoad={onLoadMap}
      mapContainerStyle={{
        width: '100%',
        height: '400px',
      }}
      center={{
        lat: (center && center.lat()) || 39.791,
        lng: (center && center.lng()) || -86.148,
      }}
      zoom={8}
    >
      {markers}
    </GoogleMap>
  )
}
